import { OneOfElements } from '@shared/models/project.model';
import { projectGuards } from '../../guards/project-guards.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

type ProductElementProductIdChange =
  ProjectChangeMap[ProjectChangeType.ProductElementProductId];

/**
 * Build a partial element change for ProductElementProductId.
 *
 * @param element - Current element state
 * @param change - Product id payload
 * @returns Partial<OneOfElements> or undefined
 */
export const productElementProductIdToChange = (
  element: OneOfElements,
  change: ProductElementProductIdChange,
): Partial<OneOfElements> | undefined => {
  if (!projectGuards.is.productElement(element)) return undefined;
  if (element.product_id === change.productId) return undefined;

  return { product_id: change.productId };
};
